module.exports = __webpack_public_path__ + "logo-alertminer.7d7cfb4cf28cc7c6c86c.png";